import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../../../../app.component';
import { AdministrationService, StorageService } from '../../service';
import { MenuItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    styleUrls: ['./app.menu.component.scss']
})
export class AppMenuComponent implements OnInit {
    userDetails$:Observable<any>;
    model: {}[];
    items: MenuItem[];
    isSuperuser: boolean=false;
    // isCozentusUser: boolean=false;
    constructor(private store: Store<any>,public adminService: AdministrationService,public app: AppComponent, public storageService: StorageService) {
    this.userDetails$ = this.store.pipe(select(state => state?.list?.data?.profile));
    }
    ngOnInit() {
        this.userDetails$.subscribe(data => {
            // this.isCozentusUser=data?.email?data?.email?.includes('cozentus'):false;
            let privilegeList=data?.privileges;
            this.items = [
                 {
                    label: 'Introduction to Astro',
                    icon: 'fas fa-book-open',
                    routerLink:['introduction/astro'],
                    routerLinkActiveOptions:{
                        exact: true
                    }
                },
                {
                    label: 'Record Tracker',
                    icon: 'fad fa-file-search',
                    routerLink:['record/tracker'],
                    visible: privilegeList?.includes('VIEW_TICKET_LIST'),
                    routerLinkActiveOptions:{
                        exact: true
                    }
                },
                {
                    label: 'Dashboard',
                    icon: 'fas fa-poll',
                    routerLink:['dashboard'],
                    visible:true,
                    routerLinkActiveOptions:{
                        exact: true
                       }
                },
                {
                    label: 'Create Supplier',
                    icon: 'fas fa-edit',
                    routerLink: ['supplier/create'],
                    visible: privilegeList?.includes('CREATE_TICKET'),
                    routerLinkActiveOptions:{
                        exact: true
                       }
                },
                {
                    label: 'Modify Supplier',
                    icon: 'fas fa-unlock',
                    routerLink: ['modify-supplier'],
                    visible: privilegeList?.includes('MODIFY_SUPPLIER_TICKET'),
                    routerLinkActiveOptions:{
                        exact: true
                       }
                },
                  {
                    label: 'Other Requests',
                    icon: 'fas fa-ethernet ethernet',
                    visible: privilegeList?.includes('OTHER_OTHER_TICKET_CREATE') || privilegeList?.includes('OTHER_BULK_BLOCK_UPDATE_TICKET') || privilegeList?.includes('OTHER_EXTEND_TO_LOB_TICKET') || privilegeList?.includes('OTHER_UPDATE_CREATE_TICKET'),
                    routerLinkActiveOptions:{
                        exact: true
                       },
                items: [
                        {
                            label: 'Other',
                            icon: 'fas fa-business-time',
                            routerLink: ['other-requests/other'],
                            expanded: window.location.href.includes('other-requests/other'),
                            visible: privilegeList?.includes('OTHER_OTHER_TICKET_CREATE'),
                            routerLinkActiveOptions: { exact: true }
                        },
                          {
                            label: 'Bulk Block/Update',
                            icon: 'fas fa-treasure-chest',
                            routerLink: ['other-requests/bulk-block-update'],
                            expanded: window.location.href.includes('other-requests/bulk-block-update'),
                            visible: privilegeList?.includes('OTHER_BULK_BLOCK_UPDATE_TICKET'),
                            routerLinkActiveOptions: { exact: true }
                        },
                         {
                            label: 'Extend to LOB',
                            icon: 'fas fa-window-restore',
                            routerLink: ['other-requests/extend-to-lob'],
                            expanded: window.location.href.includes('other-requests/extend-to-lob'),
                            visible: privilegeList?.includes('OTHER_EXTEND_TO_LOB_TICKET'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'Create/Update Employee Vendor',
                            icon: 'fas fa-user-clock',
                            routerLink: ['other-requests/create-update-employee-vendor'],
                            expanded: window.location.href.includes('other-requests/create-update-employee-vendor'),
                            visible: privilegeList?.includes('OTHER_UPDATE_CREATE_TICKET'),
                            routerLinkActiveOptions: { exact: true }
                        }
                ]
                },
                {
                    label: 'Master Data ',
                    icon: 'fas fa-list',
                    id: 'master',
                    expanded: window.location.href.includes('master-data/legal-entity') || window.location.href.includes('master-data/supplier-change-log') || window.location.href.includes('master-data/d365-md-change-log') ||
                        window.location.href.includes('master-data/sertica-database') || window.location.href.includes('master-data/lsretail-database') || window.location.href.includes('master-data/velocity-database') ||
                        window.location.href.includes('master-data/supplier-list') || window.location.href.includes('master-data/country') || window.location.href.includes('master-data/currency') || window.location.href.includes('master-data/group-procurement') ||
                        window.location.href.includes('master-data/le-bu') || window.location.href.includes('master-data/ls-retail-form-input-fields') || window.location.href.includes('master-data/payment-method') || window.location.href.includes('master-data/sales-tax') ||
                        window.location.href.includes('master-data/sertica-form-input-fields') || window.location.href.includes('master-data/sertica-le') || window.location.href.includes('master-data/sertica-configuration') ||
                        window.location.href.includes('master-data/terms-of-payment') || window.location.href.includes('master-data/velocity-form-input-fields') || window.location.href.includes('master-data/velocity-organization') ||
                        window.location.href.includes('master-data/contact-info') || window.location.href.includes('master-data/rejection-reason') || window.location.href.includes('master-data/error-code-list'),
                    visible: privilegeList?.includes('VIEW_LEGAL_ENTITY') || privilegeList?.includes('VIEW_SUPPLIER_CHANGE_LOG') || privilegeList?.includes('VIEW_SUPPLIER_DATA_RECEIVER_LOG') ||
                        privilegeList?.includes('VIEW_SERTICA_DATABASE') || privilegeList?.includes('VIEW_LS_RETAIL_DATABASE') || privilegeList?.includes('VIEW_VELOCITY_DATABASE') || privilegeList?.includes('VIEW_D365_DATABASE') || privilegeList?.includes('VIEW_COUNTRY') ||
                        privilegeList?.includes('VIEW_CURRENCY') || privilegeList?.includes('VIEW_GROUP_PROCUREMENT_APPROVERS') || privilegeList?.includes('VIEW_LE_BU') || privilegeList?.includes('VIEW_LS_RETAIL_INPUT_FIELDS') || privilegeList?.includes('VIEW_PAYMENT_METHOD') ||
                        privilegeList?.includes('VIEW_SALES_TAX_GROUPS') || privilegeList?.includes('VIEW_SERTICA_INPUT_FIELDS') || privilegeList?.includes('VIEW_SERTICA_LE') || privilegeList?.includes('VIEW_SERTICA_UNITS') ||
                        privilegeList?.includes('VIEW_PAYMENT_TERM') || privilegeList?.includes('VIEW_VELOCITY_INPUT_FIELDS') || privilegeList?.includes('VIEW_ORGANISATION') || privilegeList?.includes('VIEW_PURPOSE') || privilegeList?.includes('VIEW_JUSTIFICATION_REASON') || privilegeList?.includes('VIEW_ERROR_CODE'),
                    items: [
                        {
                            label: 'Legal Entity',
                            icon: 'fas fa-briefcase',
                            routerLink: ['master-data/legal-entity'],
                            expanded: window.location.href.includes('master-data/legal-entity'),
                            visible: privilegeList?.includes('VIEW_LEGAL_ENTITY'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'Supplier Change Log',
                            icon: 'fas fa-history',
                            routerLink: ['master-data/supplier-change-log'],
                            expanded: window.location.href.includes('master-data/supplier-change-log'),
                            visible: privilegeList?.includes('VIEW_SUPPLIER_CHANGE_LOG'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'D365 MD Change Log',
                            icon: 'fas fa-chart-line',
                            routerLink: ['master-data/d365-md-change-log'],
                            expanded: window.location.href.includes('master-data/d365-md-change-log'),
                            visible: privilegeList?.includes('VIEW_SUPPLIER_DATA_RECEIVER_LOG'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'Astro Database',
                            icon: 'fas fa-database',
                            id: 'astro-database',
                            visible: privilegeList?.includes('VIEW_SERTICA_DATABASE') ||  privilegeList?.includes('VIEW_LS_RETAIL_DATABASE') ||  privilegeList?.includes('VIEW_VELOCITY_DATABASE') ||  privilegeList?.includes('VIEW_D365_DATABASE'),
                            expanded: window.location.href.includes('master-data/sertica-database') ||
                                      window.location.href.includes('master-data/lsretail-database') ||
                                      window.location.href.includes('master-data/velocity-database'),
                            routerLink: null,
                            items: [
                                {
                                    label: 'Sertica Database',
                                    icon: 'fas fa-receipt',
                                    routerLink: ['master-data/sertica-database'],
                                    visible: privilegeList?.includes('VIEW_SERTICA_DATABASE'),
                                    routerLinkActiveOptions: {
                                        exact: true
                                    }
                                },
                                {
                                    label: 'LSRetail Database',
                                    icon: 'fas fa-tags',
                                    routerLink: ['master-data/lsretail-database'],
                                    visible: privilegeList?.includes('VIEW_LS_RETAIL_DATABASE'),
                                    routerLinkActiveOptions: {
                                        exact: true
                                    }
                                },
                                {
                                    label: 'Velocity Database',
                                    icon: 'fas fa-barcode',
                                    routerLink: ['master-data/velocity-database'],
                                    visible: privilegeList?.includes('VIEW_VELOCITY_DATABASE'),
                                    routerLinkActiveOptions: {
                                        exact: true
                                    }
                                },
                                 {
                            label: 'D365 Database',
                            icon: 'fas fa-solid fa-list-ol',
                            routerLink: ['master-data/supplier-list'],
                            expanded: window.location.href.includes('master-data/supplier-list'),
                            visible: privilegeList?.includes('VIEW_D365_DATABASE'),
                            routerLinkActiveOptions: { exact: true }
                        },
                         {
                            label: 'Special LOB Database',
                            icon: 'far fa-sparkles',
                            routerLink: ['master-data/special-lob-list'],
                            expanded: window.location.href.includes('master-data/special-lob-list'),
                            visible: privilegeList?.includes('VIEW_SPECIAL_LOB_DATABASE'),
                            routerLinkActiveOptions: { exact: true }
                        },
                            ]
                        },
                        {
                            label: 'Country',
                            icon: 'fas fa-globe',
                            routerLink: ['master-data/country'],
                            expanded: window.location.href.includes('master-data/country'),
                            visible: privilegeList?.includes('VIEW_COUNTRY'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'Currency',
                            icon: 'fal fa-rupee-sign',
                            routerLink: ['master-data/currency'],
                            expanded: window.location.href.includes('master-data/currency'),
                            visible: privilegeList?.includes('VIEW_CURRENCY'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'Group Procurement Approvers',
                            icon: 'fas fa-sitemap',
                            routerLink: ['master-data/group-procurement'],
                            expanded: window.location.href.includes('master-data/group-procurement'),
                            visible: privilegeList?.includes('VIEW_GROUP_PROCUREMENT_APPROVERS'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'LE BU Relationship',
                            icon: 'fas fa-puzzle-piece',
                            routerLink: ['master-data/le-bu'],
                            expanded: window.location.href.includes('master-data/le-bu'),
                            visible: privilegeList?.includes('VIEW_LE_BU'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'LS Retail Form Input Fields',
                            icon: 'fas fa-shopping-cart',
                            routerLink: ['master-data/ls-retail-form-input-fields'],
                            expanded: window.location.href.includes('master-data/ls-retail-form-input-fields'),
                            visible: privilegeList?.includes('VIEW_LS_RETAIL_INPUT_FIELDS'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'Method of Payment',
                            icon: 'fas fa-credit-card',
                            routerLink: ['master-data/payment-method'],
                            expanded: window.location.href.includes('master-data/payment-method'),
                            visible: privilegeList?.includes('VIEW_PAYMENT_METHOD'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'Sales Tax Groups',
                            icon: 'fas fa-file-invoice-dollar',
                            routerLink: ['master-data/sales-tax'],
                            expanded: window.location.href.includes('master-data/sales-tax'),
                            visible: privilegeList?.includes('VIEW_SALES_TAX_GROUPS'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'Sertica Form Input Fields',
                            icon: 'fas fa-sliders-h',
                            routerLink: ['master-data/sertica-form-input-fields'],
                            expanded: window.location.href.includes('master-data/sertica-form-input-fields'),
                            visible: privilegeList?.includes('VIEW_SERTICA_INPUT_FIELDS'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'Sertica Unit-D365 LE Configuration',
                            icon: 'fas fa-server',
                            routerLink: ['master-data/sertica-le'],
                            expanded: window.location.href.includes('master-data/sertica-le'),
                            visible: privilegeList?.includes('VIEW_SERTICA_LE'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'Sertica Units Configuration Table',
                            icon: 'fas fa-tools',
                            routerLink: ['master-data/sertica-configuration'],
                            expanded: window.location.href.includes('master-data/sertica-configuration'),
                            visible: privilegeList?.includes('VIEW_SERTICA_UNITS'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'Terms of Payment',
                            icon: 'fas fa-university',
                            routerLink: ['master-data/terms-of-payment'],
                            expanded: window.location.href.includes('master-data/terms-of-payment'),
                            visible: privilegeList?.includes('VIEW_PAYMENT_TERM'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'Velocity Form Input Fields',
                            icon: 'fas fa-tachometer-alt',
                            routerLink: ['master-data/velocity-form-input-fields'],
                            expanded: window.location.href.includes('master-data/velocity-form-input-fields'),
                            visible: privilegeList?.includes('VIEW_VELOCITY_INPUT_FIELDS'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'Velocity Organisation Configuration Table',
                            icon: 'fas fa-cogs',
                            routerLink: ['master-data/velocity-organization'],
                            expanded: window.location.href.includes('master-data/velocity-organization'),
                            visible: privilegeList?.includes('VIEW_ORGANISATION'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'Contact information Purpose',
                            icon: 'fas fa-phone',
                            routerLink: ['master-data/contact-info'],
                            expanded: window.location.href.includes('master-data/contact-info'),
                            visible: privilegeList?.includes('VIEW_PURPOSE'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        // {
                        //     label: 'Info Message / Error Message',
                        //     icon: 'fas fa-comment-dots',
                        //     routerLink: ['master-data/icons-error'],
                        //     expanded: window.location.href.includes('master-data/icons-error'),
                        //     visible: privilegeList?.includes('VIEW_FORM_FIELD_MESSAGE'),
                        //     routerLinkActiveOptions: { exact: true }
                        // },
                        {
                            label: 'Reason Codes',
                            icon: 'fas fa-exclamation-circle',
                            routerLink: ['master-data/rejection-reason'],
                            expanded: window.location.href.includes('master-data/rejection-reason'),
                            visible: privilegeList?.includes('VIEW_JUSTIFICATION_REASON'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'Global Fields Configuration',
                            icon: 'fas fa-check-square',
                            routerLink: ['master-data/global-field-config'],
                            expanded: window.location.href.includes('master-data/global-field-config'),
                            visible: privilegeList?.includes('VIEW_GLOBAL_FIELD_CONFIG'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'Error Code List',
                            icon: 'fas fa-bug',
                            routerLink: ['master-data/error-code-list'],
                            expanded: window.location.href.includes('master-data/error-code-list'),
                            visible: privilegeList?.includes('VIEW_ERROR_CODE'),
                            routerLinkActiveOptions: { exact: true }
                        },
                    ]
                },
                {
                    label: 'Administration ',
                    icon: 'fas fa-user-shield',
                    id:'admin',
                    visible: privilegeList?.includes('VIEW_ROLE_LIST') || privilegeList?.includes('VIEW_USER_LIST') || privilegeList?.includes('VIEW_COLUMN_CONFIGURATION') ||
                        privilegeList?.includes('VIEW_FIELD_USAGE_ACROSS_SYSTEM_CONFIG') || privilegeList?.includes('VIEW_APPLICATION_CONFIGURATION') || privilegeList?.includes('EMAIL_TEMPLATE_AUTO_LIST_VIEW') ||
                        privilegeList?.includes('EMAIL_TEMPLATE_MANUAL_LIST_VIEW') || privilegeList?.includes('VIEW_SALES_TAX_GROUP_SCRIPT') || privilegeList?.includes('VIEW_METHOD_OF_PAYMENT_SCRIPT') ||
                        privilegeList?.includes('VIEW_VELOCITY_SCRIPT') || privilegeList?.includes('VIEW_MASTER_STATUS') || privilegeList?.includes('VIEW_SLA') ||
                        privilegeList?.includes('VIEW_USER_ACTIVITY_LIST') || privilegeList?.includes('EMAIL_LOGS_VIEW') || privilegeList?.includes('NOTIFICATION_LOGS_VIEW'),
                    expanded: window.location.href.includes('admin/data-change-logger') ||  window.location.href.includes('admin/user-activity') || window.location.href.includes('admin/announcement')
                    || window.location.href.includes('admin/user-management') || window.location.href.includes('admin/column-settings')|| window.location.href.includes('admin/email-change-log') || window.location.href.includes('admin/role-management') ||window.location.href.includes('admin/file-type') ||window.location.href.includes('admin/default-config')||window.location.href.includes('admin/velocity-scripts') ||window.location.href.includes('admin/master-status'),
                    items: [
                        {
                            label: 'Roles',
                            icon: 'fas fa-user-check',
                            routerLink: ['admin/role-management'],
                            visible: privilegeList?.includes('VIEW_ROLE_LIST'),
                            routerLinkActiveOptions:{
                                exact: true
                               }
                        },
                        {
                            label: 'Users',
                            icon: 'fas fa-users-cog',
                            routerLink: ['admin/user-management'],
                            visible: privilegeList?.includes('VIEW_USER_LIST'),
                            routerLinkActiveOptions:{
                                exact: true
                               }
                        },
                        {
                            label: 'Column Settings',
                            icon: 'fad fa-line-columns',
                            // visible:this.isCozentusUser ,
                            routerLink: ['admin/column-settings'],
                            visible: privilegeList?.includes('VIEW_COLUMN_CONFIGURATION'),
                            routerLinkActiveOptions:{
                                exact: true
                               }
                        },
                        {
                            label: 'Field Usage Across the Systems Config',
                            icon: 'fal fa-wrench',
                            routerLink:['admin/default-config'],
                            visible: privilegeList?.includes('VIEW_FIELD_USAGE_ACROSS_SYSTEM_CONFIG'),
                            routerLinkActiveOptions:{
                             exact: true
                            },
                        },
                        {
                            label: 'Announcement',
                            icon:'fas fa-bullhorn',
                            routerLink: ['admin/announcement'],
                            routerLinkActiveOptions:{
                                exact: true
                               }
                        },
                        {
                            label: 'Application Configuration',
                            icon: 'fas fa-cogs',
                            routerLink: ['admin/app-configuration'],
                            visible: privilegeList?.includes('VIEW_APPLICATION_CONFIGURATION'),
                            routerLinkActiveOptions:{
                                exact: true
                               }
                        },
                        {
                            label: 'Custom Email Template',
                            icon: 'fas fa-mail-bulk',
                            id: 'custom-email-template',
                            expanded: window.location.href.includes('admin/auto-email-template') ||
                                      window.location.href.includes('admin/manual-email-template'),
                            visible: privilegeList?.includes('EMAIL_TEMPLATE_AUTO_LIST_VIEW') ||  privilegeList?.includes('EMAIL_TEMPLATE_MANUAL_LIST_VIEW'),
                            routerLink: null,
                            items: [
                                {
                                    label: 'Manual Email Template',
                                    icon: 'fas fa-envelope',
                                    routerLink: ['admin/manual-email-template'],
                                    visible: privilegeList?.includes('EMAIL_TEMPLATE_MANUAL_LIST_VIEW'),
                                    routerLinkActiveOptions: {
                                        exact: true
                                    }
                                },
                                {
                                    label: 'Auto Email Template',
                                    icon:'far fa-envelope-square',
                                    routerLink: ['admin/auto-email-template'],
                                    visible: privilegeList?.includes('EMAIL_TEMPLATE_AUTO_LIST_VIEW'),
                                    routerLinkActiveOptions: {
                                        exact: true
                                    }
                                }
                            ]
                        },
                        {
                            label: 'Scripts',
                            icon: 'fas fa-code',
                            id: 'scripts',
                            visible: privilegeList?.includes('VIEW_SALES_TAX_GROUP_SCRIPT') ||  privilegeList?.includes('VIEW_METHOD_OF_PAYMENT_SCRIPT') ||  privilegeList?.includes('VIEW_VELOCITY_SCRIPT'),
                            expanded: window.location.href.includes('admin/sales-tax-scripts') ||
                                      window.location.href.includes('admin/payment-method-scripts') ||
                                      window.location.href.includes('admin/velocity-scripts'),
                            routerLink: null,
                            items: [
                                {
                                    label: 'Sales Tax Group Scripts',
                                    icon: 'fas fa-bolt',
                                    routerLink: ['admin/sales-tax-scripts'],
                                    visible: privilegeList?.includes('VIEW_SALES_TAX_GROUP_SCRIPT'),
                                    routerLinkActiveOptions: {
                                        exact: true
                                    }
                                },
                                {
                                    label: 'Method of payment Scripts',
                                    icon: 'fas fa-file-invoice',
                                    routerLink: ['admin/payment-method-scripts'],
                                    visible: privilegeList?.includes('VIEW_METHOD_OF_PAYMENT_SCRIPT'),
                                    routerLinkActiveOptions: {
                                        exact: true
                                    }
                                },
                                {
                                    label: 'Velocity Scripts',
                                    icon: 'fas fa-scroll',
                                    routerLink: ['admin/velocity-scripts'],
                                    visible: privilegeList?.includes('VIEW_VELOCITY_SCRIPT'),
                                    routerLinkActiveOptions: {
                                        exact: true
                                    }
                                }
                            ]
                        },
                        {
                            label: 'Status',
                            icon: 'fas fa-table',
                            routerLink: ['admin/master-status'],
                            expanded: window.location.href.includes('admin/master-status'),
                            visible: privilegeList?.includes('VIEW_MASTER_STATUS'),
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        },
                        {
                            label: 'SLA',
                            icon: 'fas fa-stopwatch',
                            routerLink: ['admin/sla'],
                            expanded: window.location.href.includes('admin/sla'),
                            visible: privilegeList?.includes('VIEW_SLA'),
                            routerLinkActiveOptions: {
                                exact: true
                            }
                        },
                        {
                            label: 'User Activity Log',
                            icon: 'fal fa-user-clock',
                            routerLink:['admin/user-activity'],
                            visible: privilegeList?.includes('VIEW_USER_ACTIVITY_LIST'),
                            routerLinkActiveOptions:{
                             exact: true
                            },
                        },
                        {
                            label: 'Email Log',
                            icon: 'fas fa-envelope-open-text',
                            routerLink: ['admin/email-change-log'],
                            expanded: window.location.href.includes('admin/email-change-log'),
                            visible: privilegeList?.includes('EMAIL_LOGS_VIEW'),
                            routerLinkActiveOptions: { exact: true }
                        },
                        {
                            label: 'Update Request Log',
                            icon: 'fas fa-edit',
                            routerLink: ['admin/update-request-log'],
                            expanded: window.location.href.includes('admin/update-request-log'),
                            visible:false,
                            routerLinkActiveOptions: { exact: true }
                        },

                        {
                            label: 'Notification Log',
                            icon: 'fas fa-bell',
                            routerLink: ['admin/notification-log'],
                            expanded: window.location.href.includes('admin/notification-log'),
                            visible: privilegeList?.includes('NOTIFICATION_LOGS_VIEW'),
                            routerLinkActiveOptions: { exact: true }
                        },
                    ]
                }
            ]
        });
    }
}

